import React, { useState, useEffect, useRef, useMemo } from 'react';
import axios from 'axios';
import { Row, Col, Button, Card, Modal, Form, Tab, Nav } from 'react-bootstrap'
import { useParams } from 'react-router-dom';
import JoditEditor from 'jodit-react';

function InstagramTemplates(props) {
    const [templates, setTemplates] = useState([])
    const [selectedTemplate, setSelectedTemplate] = useState({})
    const [showForm, setShowForm] = useState(false)
    const [updatingdata, setUpdatingdata] = useState(false)
    const [showstartmodal, setShowstartmodal] = useState(false)

    const [modifymode, setmodifymode] = useState(false)
    const [validated, setValidated] = useState(false);
    const [formData, setFormData] = useState({ batchsize : 500, offset: 0 })
    const [jobs, setJobs] = useState([])
    const [selectedjob, setSelectedJob] = useState()
    const [loading, setLoading] = useState(false)

    let { campaignid } = useParams()
    const editor = useRef(null);
    const config =useMemo(()=>{ return {
        readonly: false, // all options from https://xdsoft.net/jodit/docs/,
        placeholder: 'Start typing...',
        height:375
    }},[]); 

    const getTemplates = (uid) => {
        axios.get(`/instagramtemplates/userid/${uid}`)
            .then(res => {
                setTemplates(res.data)
            })
            .catch(err => {
                console.log(err)
            })
    }

    const getJobs = (id) => {
        axios.post(`/getlists/${id}`)
            .then(res => {
                setJobs(res.data)
            })
            .catch(err => {
                console.log(err)
            })
    }

    const disableCForm = () => {
        setShowForm(false);
    }

    useEffect(() => {
        if (parseInt(campaignid) > 0) {
            setShowstartmodal(true)
        }
    }, [])

    useEffect(() => {
        getTemplates(props.uid)
        getJobs((props.uid))
    }, [showForm, updatingdata])


    const deleteTemplate = (template) => {
        setSelectedTemplate(template)
        if (window.confirm('Are you sure you want to delete this Template?')) {
            setUpdatingdata(true)
            axios.delete(`/instagramtemplates/${template.id}`)
                .then(res => {
                    setUpdatingdata(false)
                })
                .catch(err => alert('Something wrong happened. Can you please try after some time?'))
        }
    }

    const modifyTemplate = (template) => {

        setSelectedTemplate(template)
        axios.get(`/instagramtemplates/${template.id}`)
            .then((res) => {
                let template = res.data[0]
                setFormData(template)
            })
            .catch(error => console.log(error))

        setmodifymode(true)
        setShowForm(true)
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value })
    }

    const handleSubmit = async (event) => {
        const form = event.currentTarget;

        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        }
        else if (form.checkValidity() === true) {
            event.preventDefault();
            event.stopPropagation();
            const response = await axios.post(
                '/instagramtemplates',
                {
                  ...formData,
                  createdby: props.uid
                },
                {
                  headers: {
                    Authorization: `Bearer ${sessionStorage.getItem('jwttoken')}`,
                    'Content-Type': 'application/json'
                  }
                }
              );
            if (response.status === 200) {
                alert('Instagram template created')
                setFormData({})
                setValidated(true)
                setShowForm(false)
            }
            else {
                alert('Something wrong happened. Can you please try after some time?')
            }
        }


    };

    const handleUpdate = async (event) => {
        const form = event.currentTarget;

        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        }
        else if (form.checkValidity() === true) {
            event.preventDefault();
            event.stopPropagation();

            const response = await axios.put(
                '/instagramtemplates',
                {
                  ...formData,
                  modifiedby: props.uid
                },
                {
                  headers: {
                    Authorization: `Bearer ${sessionStorage.getItem('jwttoken')}`,
                    'Content-Type': 'application/json'
                  }
                }
              );

            if (response.status === 200) {
                alert('Instagram template Modified')
                setFormData({})
                setValidated(true)
                setShowForm(false)
            }
            else {
                alert('Something wrong happened. Can you please try after some time?')
            }
        }

        setValidated(true);
    }

    const handlejobselect = (event) => {
        setSelectedJob(event.target.value)
    }

    const startcampaign = () => {
		if (selectedjob > 0) {
            setLoading(true)
			axios.post(`/startinstagramcampaign`,{ 
				tid : selectedTemplate.id, 
				jid : selectedjob,  
				startedby : props.uid,
                limit:formData.batchsize, 
                offset:formData.offset
			 })
				.then(res => {
					setLoading(false)
                    alert(`Campaign Added!`)
                    setShowstartmodal(false)
				})
				.catch(err => {
                    console.log(err)
                })
		} else {
            alert('You need to select a list to start a campaign')
		}

    }

    return (
        <>
        <style>
            {`
                .card-fixed {
                    height: 220px;
                    display: flex;
                    flex-direction: column;
                }

                .card-body-fixed {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    overflow: hidden;
                }

                .content-area {
                    flex: 1;
                    overflow: hidden;
                }

                .clamp-text {
                    display: -webkit-box;
                    -webkit-line-clamp: 3;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                }
            `}
        </style>

    
        <React.Fragment>

            <div className='w-100 h-100 d-flex flex-column overflow-hidden'>
                <Tab.Container defaultActiveKey="instagramtemplates">
                    <Nav variant='tabs' className='fs-6 border' >
                        <Nav.Item><Nav.Link eventKey="instagramtemplates">Instagram Templates</Nav.Link></Nav.Item>
                        <Nav.Item className='ms-auto'>
                            <Button title="New Form Template" className={`btn btn-primary mx-1 float-right`} onClick={() => setShowForm(true)}><i class={`bi bi-plus text-white`} style={{ fontWeight: 'bold' }}></i></Button>
                            <Button title="Refresh" className={`btn btn-primary mx-1 float-right`} onClick={getTemplates}><i class={`bi bi-arrow-repeat`}></i></Button>
                        </Nav.Item>
                    </Nav>
                    <Tab.Content className='w-100' style={{ height: "calc(100% - 34px)" }} animation={true} mountOnEnter={true} unmountOnExit={true} >
                        <Tab.Pane className='w-100 h-100 d-flex flex-column' eventKey="instagramtemplates" title="Instagram Templates">
                            {/* <ContactFormTemplates setrefresh={setTemplateRefresh} refresh={templateRefresh} setCampaignRefresh={setCampaignRefresh} handleTabSelection={handleTabSelection} uid={props.uid} setSelectedTemplate={setSelectedTemplate} setTemplates={setTemplates} isCreateTemplateVisible={isCreateTemplateVisible} showForm={showForm} setShowForm={setShowForm} /> */}
                            <div className='flex-grow-1 overflow-auto'>
                                <Row className="m-0 p-2">
                                {templates.map((row, index) => (
                                        <Col className='m-1' style={{ width: '100%', minWidth: '199px' }}>
                                        <Card
                                            key={index}
                                            onClick={() => setSelectedTemplate(templates[index])}
                                            title={`Template [ID-${row.id}]`}
                                                className={`text-primary ${(row.id === selectedTemplate.id) ? `border-primary shadow-lg` : ''} card-fixed`}
                                        >
                                            <Card.Header className={`text-white bg-primary p-0 align-items-center`}>
                                                <div className="d-flex flex-row">
                                                    <div className="p-2"><span>{`Template [ID-${row.id}]`}</span></div>
                                                </div>
                                            </Card.Header>
                                                <Card.Body className='p-2 card-body-fixed'>
                                                    <div className="content-area">
                                                    <Row className="mx-0 border-top"><Col className="p-0"><b>Name</b></Col></Row>
                                                        <Row className="mx-0"><Col className="ps-1 clamp-text">{row.name}</Col></Row>
                                                    <Row className="mx-0 border-top"><Col className="p-0"><b>Description</b></Col></Row>
                                                        <Row className="mx-0"><Col className="ps-1 clamp-text">{row.message}</Col></Row>
                                                    </div>
                                                    <div>
                                                    <Row className={`w-100 m-0`}>
                                                        <Col className="p-0 d-flex">
                                                            <Button id={`btnm-${row.id}`} size="sm" variant="outline-primary" style={{ borderRadius: "50%" }} className="me-1 border border-gray" onClick={() => { modifyTemplate(templates[index]) }}><i class="bi bi-pencil-square"></i></Button>
                                                            <Button id={`btnc-${row.id}`} size="sm" variant="outline-primary" title="Start Campaign" style={{ borderRadius: "50%" }} className="me-1 border border-gray" onClick={() => {setSelectedTemplate(row); setFormData({ batchsize: row.batchsize ?? 500, offset: row.offset ?? 0}) ;setShowstartmodal(true); }}><i class="bi bi-play"></i></Button>
                                                            <Button id={`btnd-${row.id}`} size="sm" variant="outline-primary" title="Delete Template" style={{ borderRadius: "50%" }} className="ms-auto border border-gray" onClick={() => { deleteTemplate(templates[index]) }}><i className="bi bi-trash"></i></Button>
                                                        </Col>
                                                    </Row>
                                                    </div>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                ))}
                            </Row>
                            </div>
                        </Tab.Pane>
                    </Tab.Content>
                </Tab.Container>
            </div>

            <Modal show={showForm} onHide={disableCForm} className='shadow-lg' centered size="md" enforceFocus={false} >
                <Modal.Header className='py-2 bg-primary text-white'>
                    <div className="fs-5">{modifymode ? 'Modify Template' : 'Create Template'}</div>
                </Modal.Header>
                <Modal.Body className="m-1 p-4">
                    <div className={`d-flex flex-column`}>
                        <Form noValidate validated={validated} onSubmit={(e) => modifymode ? handleUpdate(e) : handleSubmit(e)}>
                            <Row className="mb-3">
                                <Col>
                                    <Form.Group >
                                        <Form.Label className='fw-bold'>Name{<span style={{ color: 'red' }}>*</span>}</Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={formData.name}
                                            name='name'
                                            onChange={handleChange}
                                            required
                                            pattern={'^[a-zA-Z 0-9]+$'}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please provide a valid name.
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col>
                                    <Form.Group >
                                        <Form.Label className='fw-bold'>Batch Size{<span style={{ color: 'red' }}>*</span>}</Form.Label>
                                        <Form.Control
                                            type="number"
                                            value={formData.batchsize}
                                            name='batchsize'
                                            onChange={handleChange}
                                            required
                                            max={500}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please provide a valid Batch Size.
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group >
                                        <Form.Label className='fw-bold'>Offset{<span style={{ color: 'red' }}>*</span>}</Form.Label>
                                        <Form.Control
                                            type="number"
                                            value={formData.offset}
                                            name='offset'
                                            onChange={handleChange}
                                            required
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please provide a valid Offset.
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col>
                                    <Form.Group >
                                        <Form.Label className='fw-bold'>Message{<span style={{ color: 'red' }}>*</span>}</Form.Label>
                                        <JoditEditor 
                                                ref={editor}
                                                value={formData.message}
                                                config={config}
                                                tabIndex={1} // tabIndex of textarea
                                                onBlur={newContent =>  setFormData({ ...formData, message: newContent })} // preferred to use only this option to update the content for performance reasons
                                                onChange={newContent => setFormData({ ...formData, message: newContent })}
                                        />
                                        {/* <Form.Control
                                            as="textarea"
                                            value={formData.message}
                                            name='message'
                                            onChange={handleChange}
                                            required
                                        /> */}
                                        <Form.Control.Feedback type="invalid">
                                            Please provide a valid message.
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>

                            </Row>

                            <Form.Control
                                type="hidden"
                                value={formData.id}
                                name='id'
                            />

                            <div className='d-flex justify-content-end'>
                                <Button className='mx-1' variant="secondary" onClick={() => { setShowForm(false); setFormData({}); setmodifymode(false); setValidated(false); }}>
                                    Cancel
                                </Button>

                                <Button type='submit' className={`mx-1`} variant="primary">
                                    {modifymode === true ? 'Update' : 'Create'}
                                </Button>

                            </div>

                        </Form>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={showstartmodal} onHide={() => setShowstartmodal(false)} size='lg' className='shadow-lg' centered>
                <Modal.Header className='py-2 bg-primary text-white' >
                    <div className="fs-5">Create Instagram Campaign</div>
                </Modal.Header>
                <Modal.Body className="p-3 pb-0 w-100">
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Lists</Form.Label>
                            <Form.Select id="selectOptions" onChange={handlejobselect} >
                                <option key="default" value={-1}>
                                    Select list
                                </option>
                                {jobs.map((option, index) => (
                                    // <option key={index} value={option.id} disabled={[2, 3].includes(option.status) ? false : true}>
                                    //     {option.name}
                                    // </option>
                                    <option key={index} value={option.value} >
                                        {option.label}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex justify-content-end'>
                        <Button className="mx-1" title="Cancel" variant="secondary" onClick={() => setShowstartmodal(false)}>
                            Cancel
                        </Button>

                        <Button className={`mx-1`} title="Start a campaign with selected Template" variant="primary" onClick={startcampaign}>
                            Add Campaign in Queue
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>

        </React.Fragment>
        </>
    );
}

export default InstagramTemplates;